import Vue from "vue";
import Router from "vue-router";
import AuthGuard from "./auth-guard";

Vue.use(Router);

export default new Router({
  mode: "history",
  routes: [
    {
      beforeEnter: AuthGuard,
      path: "/",
      name: "home",
      component: () =>
        import(/* webpackChunkName: "home" */ "../views/Home.vue"),
    },
  ],
});
